import { Typography } from '@mui/material'
import React from 'react'
import { animations } from '../animations'

export const Header = () => {
  return (
    <header className={animations.fadeDown} style={{
      width: '100%',
      display: 'flex',
      alignItems:'center',
      flexDirection: 'column',
      gap: 32,
      marginTop: 24
      // position: 'fixed',
      // left: 0,
      // top: 0,
      // padding: 16
    }}> 
        <img src="/images/logo.png" alt="UNU Gas a un click" style={{      
          // width: 200,
          height: 75,
          display: 'block'
        }}/>
      <Typography variant="h3" align="center" color="#F6C449" fontWeight="bold">
        ¡Tu factura en minutos!
      </Typography>
    </header>
  )
}
